import { render, staticRenderFns } from "./SelectWithButtons.vue?vue&type=template&id=40873527&scoped=true"
import script from "./SelectWithButtons.vue?vue&type=script&lang=js"
export * from "./SelectWithButtons.vue?vue&type=script&lang=js"
import style0 from "./SelectWithButtons.vue?vue&type=style&index=0&id=40873527&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40873527",
  null
  
)

export default component.exports